export default {
  namespaced: true,
  state: {
    area: 0,
    vaccineType: 0
  },
  getters: {
    getCurrentArea: state => {
      return state.area
    },
    getVaccineType: state => {
      return state.vaccineType
    }
  },
  mutations: {
    setCurrentArea (state, area) {
      state.area = area
    },
    setVaccineType (state, vaccineType) {
      state.vaccineType = vaccineType
    }
  }
}
